<template>
  <ContentWithHeader>
    <template #header>
      <button
        class="btn no-bg"
        @click="setPosSection('choose-product')"
      >
        <i class="fas fa-times"/>
      </button>
    </template>

    <template #content>
      <div class="wrapper-content">
        <div class="row">
          <div class="col-12 mt-4 mb-2">
            <strong>
              {{ $t('apps.pos.message.categories') }}
            </strong>
          </div>
        </div>
        <div class="container-items row">
          <div
            v-for="(cat, index) in mapCategories"
            v-if="cat.productCount > 0 || ['1', '2'].includes(cat.id)"
            :key="index"
            class="item"
            @click="handleClickCategory(cat.id)"
          >
            <div class="info">
              <span
                v-if="cat.icon.name"
                class="icon mr-3">
                <i
                  :style="[{width: cat.icon.size}, { color: cat.icon.color }]"
                  :class="[cat.icon.name]"
                />
              </span>
              <span>
                {{ cat.name }}
              </span>
            </div>
            <div class="count">
              {{ cat.productCount }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </ContentWithHeader>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContentWithHeader from '../common/ContentWithHeader.vue'

export default {
  components: {
    ContentWithHeader,
  },

  computed: {
    ...mapGetters({
      posProducts: 'getPosProducts',
    }),
    products() {
      let allProducts = this.posProducts.find((item) => item.category_id == '2')
      if (allProducts) {
        allProducts = allProducts.products
      }
      return this.posProducts.map((item) => {
        if (['1', '2'].includes(item.category_id)) {
          return {
            ...item,
            productsCount: item.products.length,
          }
        }
        const products = allProducts.filter((product) => {
          return product.category_id === item.category_id
        })
        return {
          ...item,
          products: this.category_id == item.category_id ? products : [],
          productsCount: products.length,
        }
      })
    },
    mapCategories() {
      return this.products.map((cat) => {
        let iconName = null
        let iconSize = null
        let iconColor = null
        let name = null

        if (cat.category_id == '1') {
          iconName = 'fas fa-star'
          iconSize = '18px'
          iconColor = '#F7A621'
          name = this.$t('message.favorite')
        } else if (cat.category_id == '2') {
          iconName = 'fas fa-cubes'
          iconSize = '18px'
          iconColor = null
          name = this.$t('apps.pos.message.allproducts')
        } else {
          name = cat.category_name
        }

        return {
          id: cat.category_id,
          icon: {
            name: iconName,
            size: iconSize,
            color: iconColor,
          },
          name,
          productCount: cat.productsCount,
        }
      })
    },
  },

  methods: {
    ...mapActions([
      'setPosSection',
      'changePosCategory',
    ]),
    handleClickCategory(catId) {
      this.changePosCategory(catId)
      this.setPosSection('choose-product')
    },
  },
}
</script>

<style scoped>
.wrapper-content {
  margin: 0 15px;
}
.container-items {
  display: flex;
  flex-direction: column;
}
.item {
  padding: 10px 15px;
  background: #fff;
  border-bottom: solid 1px #F2F2F2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.item .info {
  display: flex;
}
.item .info .icon {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/CategoryList.vue